/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const AirplaneSideBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path d="M21.008 10.832c.577.09.992.588.992 1.168s-.415 1.077-.992 1.168c-.924.145-2.302.332-3.28.332h-2.832l-5.822 8.286a.505.505 0 0 1-.413.214H7.634a.5.5 0 0 1-.468-.684l3.108-7.816H5.132l-1.12 2.224a.504.504 0 0 1-.45.276H2.504a.5.5 0 0 1-.489-.621L2.865 12l-.85-3.379A.5.5 0 0 1 2.504 8h1.058c.19 0 .365.107.45.276l1.12 2.224h5.142L7.166 2.684A.5.5 0 0 1 7.634 2h1.027c.165 0 .32.08.413.214l5.822 8.286h2.831c.98 0 2.357.187 3.281.332Z" /></svg>);
const AirplaneSide = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={AirplaneSideBase} {...rest} ref={ref} />);
export default AirplaneSide;